import TruncateText from "@/shared/components/TruncateText";

const ControlSpecificationsSections = ({ data }: { data: any }) => {

  const entries = Array.from(data?.value.entries());
  const columns = 2;

  return <div>
    <div
      className="rounded-2xl"
      style={{
        border: "1px solid #ccc",
        overflow: "hidden",
      }}
    >
      <table className="border border-gray-300 border-collapse rounded-2xl overflow-hidden w-full">
        <tbody>
          {Array.from({ length: Math.ceil(entries.length / columns) }).map((_, rowIdx) => {
            const row: typeof entries = entries.slice(rowIdx * columns, (rowIdx + 1) * columns);
            const isLastRow = rowIdx === Math.floor(entries.length / columns);

            return (
              <tr key={rowIdx}>
                {row.map(([key, { title, value }]: any) => {
                  const isOnlyOneInLastRow = isLastRow && row.length === 1;

                  return (
                    <td
                      key={key}
                      className="border border-gray-300 p-4 align-top"
                      colSpan={isOnlyOneInLastRow ? columns : 1}
                    >
                      <div className="font-medium mb-1">{title}</div>
                      <div><TruncateText text={value} /></div>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
}


export default ControlSpecificationsSections